export const AutoHideEmailEvent = 'autoHideEmail';
